import { useState } from "react"
import styles from './styles.module.scss'

export default function SelectOption({options,setIndex,index,nameOption}){

    function Voltar(){
        setIndex(index-1)
        
        if(index<=0) {
            setIndex(options.length-1)
        }
    }

    function Proximo() {
        setIndex(index+1)
        if(index>=options.length-1) {
            setIndex(0)
        }
    }

    return (
    <div className={styles.option}>
        <button className={styles.button} onClick={Voltar}>{"<"}</button> <p>{nameOption +" #"+(index+1)}</p> <button onClick={Proximo} className={styles.button}>{">"}</button>
    </div>
    )
}